import React from 'react';

function Categories(){

	return <div>
		<h1>Fetching Page...</h1>
	</div>

}
export default Categories

